@if (employeeListService.loading()) {
  <div class="py-1 client-skeleton-wrapper">
    @for (i of [1, 2, 3, 4, 5, 6]; track i) {
      <bn-client-info-skeleton />
    }
    <div class="fade-gradient-overlay"></div>
  </div>
} @else {
  <div class="flex flex-col h-full">
    <div>
      @if (collapsed) {
        <ng-container *ngTemplateOutlet="conversationList; context: {
        $implicit: employeeListService.sessions(),
        scrollHeight: 'calc(100vh - 133px - .5rem)'
      }"></ng-container>
      } @else {
        <ng-container *ngTemplateOutlet="conversationList; context: {
        $implicit: employeeListService.sessions(),
        scrollHeight: 'calc(100vh - 170px - .5rem)'
      }"></ng-container>
      }
    </div>

    <!-- Footer -->
    <div class="flex items-center justify-center border-t-2 border-surface-200 pt-2">
      <button (click)="routeTo()">
        <i
          class="pi pi-home mr-2"
          aria-label="Return to My Clients"
          [pTooltip]="collapsed ? 'Return to My Clients' : undefined"
          tooltipPosition="top"
        ></i>
        @if (!collapsed) {Return to My Clients}
        </button>
      </div>
    </div>
  }
  <ng-template #conversationList let-conversations let-scrollHeight="scrollHeight">
    @if (!collapsed) {
      <div class="py-2 px-2 text-sm font-medium text-surface-600">
        @if (employeeSearchService.activeEmployee()?.firstName) {
          {{ employeeSearchService.activeEmployee()?.firstName }} {{ employeeSearchService.activeEmployee()?.lastName }}'s Conversations
        } @else {
          Employee Conversations
        }
      </div>
    }
    <bds-scroll-region
      styleClass="pb-2"
      [height]="scrollHeight"
      ariaLabel="Employee conversations"
    >
      @if (conversations.length > 0) {
        <div class="bds-list-stack">
          @for (conversation of conversations; track conversation) {
            <div
              [attr.data-conversation]="conversation.conversationId"
              tabindex="-1"
            >
              <lib-conversation-info
                [conversationInfo]="conversation"
                [selected]="conversation.conversationId === employeeListService.activeConversation()?.conversationId"
                [collapsed]="collapsed"
                [type]="'employee'"
                (conversationClicked)="conversationSelected($event)"
              />
            </div>
          }
        </div>
      } @else if (!collapsed) {
        <div class="flex items-center justify-center">
          @if (employeeSearchService.activeEmployee()) {
            {{ employeeSearchService.activeEmployee()?.firstName }} doesn't have any conversations
          } @else {
            Please search for an employee.
          }
        </div>
      }
    </bds-scroll-region>
  </ng-template>
